import React, { useState ,useEffect } from 'react'
import { Button, Input, Select, Table ,Checkbox, Form, Row, Col, DatePicker, AutoComplete ,} from "antd";
import "aos/dist/aos.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import { PlusOutlined } from "@ant-design/icons";
import { GetOrderByDiaNumber, GetOrderByPressNumber, ReportOrderPaper } from '../../AllAPI/ProductionOrderAPI/ProductionOrderApi';
import { DiaMasterGet } from '../../AllAPI/MasterAPI/DiesMasterApi';
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi';
import { FaFile, FaFilePdf } from 'react-icons/fa6';
//  import "../../MainCSS.css";
import { Spin } from "antd";
import { GetPressMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi';



const Order = () =>  {
   const commonHeaders = {
      headers: {
        createdBy: 1,
        updatedBy: 2,
        userIp: '',
        userLat: '',
        userLong: '',
        deviceSign: '',
      },
    };
    // Fetch Pending Order Summary, Customer and Item Names
      let isOrderPaperFetched = false;
      useEffect(() => {
        if (isOrderPaperFetched) return;
       
         fetchPress();
        isOrderPaperFetched = true;
      }, []);
  
     const [errors, setErrors] = useState({
     
  
        });
      
        const [pageSize, setPageSize] = useState(10);
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalEntries, setTotalEntries] = useState(0);
        const [OrderPaperData, setOrderPaperData] = useState([]);
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
                  const [diaOptions, setDiaOptions] = useState([]);
                    const [pressOptions, setPressOptions] = useState([])
                  
                  const [loading, setLoading] = useState(false);

                  const [selectedPressNumber, setSelectedPressNumber] = useState(null);
                  




   const [submitButton, setSubmitButton] = useState(true);
        const [updateButton, setUpdateButton] = useState(false);
        const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']
        const diaNumberOptions = [
          { value: '1', label: '5' },
          { value: '2', label: '7' },
          //  { value: '3', label: '5,7' },
        ]
       
        //======Search data from table===============
        const handleSearch = (value) => {
          const filtered = OrderPaperData.filter((item) =>
            item.diaNumber?.toString().toLowerCase().includes(value.toLowerCase())
          );
          setFilteredData(filtered);
          setTotalEntries(filtered.length); // Update total entries count after filtering
          setCurrentPage(1);
        };
        const handleSearchPressNumber = (PressId) => {
          if (PressId) {
            fetchOrderPaper(PressId);
            setSelectedPressNumber(PressId);
          } else {
            // If no PressId is selected, you might want to reset the table data
            setOrderPaperData([]);
            setFilteredData([]);
            setTotalEntries(0);
          }
        };
        
        //==========Pagination=======================
        const handlePageSizeChange = (value) => {
          setPageSize(value);
        };
          // ==============Get table data================

  let isError = false;

   const fetchOrderPaper = async (PressId) => {
  
    try {
      const response = await axios.get(`${GetOrderByPressNumber}?pressNameId=${PressId}`,commonHeaders);
     if (response.data && response.data.length > 0) {
      // If data is not null and not an empty array
      setOrderPaperData(response.data);
      setFilteredData(response.data);
      setTotalEntries(response.data.length); // Set the total number of entries
    } else {
      // If data is null or empty
      toast.warn("No data available for this press.");
      setOrderPaperData([]);      // Reset the order paper data
      setFilteredData([]);        // Reset the filtered data
      setTotalEntries(0);         // Reset total entries count
    }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };
  const fetchDiaMaster = async () => {
    try {
      const response = await axios.get(DiaMasterGet,commonHeaders);
      if (response.data !== null) {
     setDiaOptions(response.data);
    } }catch (error) {
      if (!isError) {
        console.error("Error fetching Dia Master data:", error);
        toast.error("Failed to fetch Dia Master data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };     
  const fetchPress = async () => {
    try {
      const response = await axios.get(GetPressMaster, commonHeaders)
      if (response.data !== null) {
        setPressOptions(response.data)
        
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Press:', error)
        toast.error('Failed to fetch Press data')
        isError = true
      }
    }
  }
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedRowKeys(filteredData.map((item) => item.id));
    } else {
      setSelectedRowKeys([]);
    }
  };
const allIds = filteredData.map(item => item.id);
const selectedCount = selectedRowKeys.length;
const isAllSelected = selectedCount === allIds.length;
const isIndeterminate = selectedCount > 0 && selectedCount < allIds.length;

const rowSelection = {
  selectedRowKeys,
  onChange: setSelectedRowKeys,
  columnTitle: (
    <Checkbox
      indeterminate={isIndeterminate}
      checked={isAllSelected}
      onChange={e => {
        if (e.target.checked) setSelectedRowKeys(allIds);
        else setSelectedRowKeys([]);
      }}
    />
  ),
};


const columns = [
  // {
  //   title: "Select",
  //   dataIndex: "checkbox",
  //   key: "checkbox",
  //   render: (_, record) => (
  //     <Checkbox
  //       checked={selectedRowKeys.includes(record.id)}
  //       onChange={() => {
  //         const selected = [...selectedRowKeys];
  //         const index = selected.indexOf(record.id);
  //         if (index > -1) {
  //           selected.splice(index, 1);
  //         } else {
  //           selected.push(record.id);
  //         }
  //         setSelectedRowKeys(selected);
  //       }}
  //     />
  //   ),
  // },
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Pending Order Id",
    dataIndex: "pendingOrder",
    key: "pendingOrder",
    sorter:  (a, b) => a.pendingOrder?.localeCompare(b.pendingOrder),
  },
  {
    title: "Item Name",
    dataIndex: "dieName",
    key: "dieName",
    sorter: (a, b) => a.dieName?.localeCompare(b.dieName),
  },
  {
    title: "Alloy",
    dataIndex: "alloyname",
    key: "alloyname",
    sorter: (a, b) => a.alloyname?.localeCompare(b.alloyname),
  },
  {
    title: "Temper",
    dataIndex: "temperName",
    key: "temperName",
    sorter: (a, b) => a.temperName?.localeCompare(b.temperName),
  },
  {
    
    title: "Weight",
    dataIndex: "weight",
    key: "weight",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => a.weight - b.weight,
  },
  // {
  //   title: "Length",
  //   dataIndex: "length",
  //   key: "length",
  //       render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

  //   sorter: (a, b) => a.length - b.length,
  // },
    {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
  {
    title: "Pcs",
    dataIndex: "pcs",
    key: "pcs",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => a.pcs - b.pcs,
  },
  {
    title: "Qty",
    dataIndex: "qty",
    key: "qty",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => a.qty - b.qty,
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => a.customerName?.localeCompare(b.customerName),
  },
];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023e7d",
            color: "#fff",
            padding: "10px",
            fontSize: "15px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
                  fontSize: '15px',

          }}
        >
          {children}
        </td>
      ),
    },
  };
 
  const handleGenerateReport = async() => {
    if (!selectedPressNumber) {
      toast.warning("Please select a Dia Number first");
      return;
    }
   

  try{
    setLoading(true);
    const selectedIds = selectedRowKeys.join(','); 
    const url = `${ReportOrderPaper}?pressNameId=${selectedPressNumber}&selectedItemIds=${selectedIds}`;

    const response = await axios.get(url, commonHeaders);
    
    if (response.data !== null) {
      if (response.data === "NOTFOUND" || response.data === "NODATA" || response.status === 204) {
        toast.warn("No data available!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
       
        return; // Exit function early
      }

      let reportUrl = response.data;
      console.log("Response data:", response.data);
      if (reportUrl === "FILENOTFOUND") {
        toast.warn("Jrxml File Not Found...!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } 
     else if (reportUrl === "NOTFOUND") {
        toast.warn("Report File Not Found...!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        const reportLink =  BaseIPForPDF + `output/${reportUrl}`;
        window.open(reportLink, "_blank");
      }
    }}
    catch (error) {
      
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
    finally {
      setLoading(false);
    }
    
  };
 
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">

  <Spin
  spinning={loading}
  tip={<span style={{ fontSize: "18px", fontWeight: "500" }}>Generating report...</span>}
>
    <div className="p-0 m-0">
 <div className="row px-md-5 mt-3 p-2">
    <div className="row p-0 m-0">
      <div className="col-12 col-lg-4"></div>

      <div className="col-12 col-lg-4 py-1">
        <label className="labels">Select Press</label>
        <Select
          showSearch
          allowClear
          placeholder="Select Press Number"
          optionFilterProp="children"
          onChange={handleSearchPressNumber}
          style={{ width: "100%", marginBottom: 16 }}
          // filterOption={(input, option) =>
          //   option.children &&
          //   option.children.toLowerCase().includes(input.toLowerCase())
          // }
        >
             {pressOptions.map((opt) => (
                                                   <Option key={opt.id} value={opt.id}>
                                                     {opt.pressName}
                                                   </Option>
                                                 ))}
        </Select>
      </div>

      <div className="col-12 col-lg-4"></div>
    </div>

  </div>

       {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">

                           <div
                             className="col-12 py-3 shadow border"
                             style={{  backgroundColor: "white" }}
                           >
              <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>

                               <div>
                                 <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                 <Select
                                   defaultValue={pageSize}
                                   onChange={handlePageSizeChange}
                                   style={{ width: 120, textAlign: "center" }}
                                 >
                                   <Option value={10}>10</Option>
                                   <Option value={20}>20</Option>
                                   <Option value={30}>30</Option>
                                 </Select>
                               </div>
                    <div className="pt-4 pt-md-0">
                    <Button
      type="primary"
      onClick={handleGenerateReport}
      style={{ width: 150, marginBottom: 16 }}

    >
   <FaFile/> Generate Report
    </Button>
       
                      {/* <Input.Search
                        placeholder="Search"
                        // onSearch={handleSearch}
                        style={{ width: 200, marginBottom: 16 }}
                      /> */}
                   

                    </div>
                  </div>
               
                  <div style={{ backgroundColor: "white" }}>
                    <Table
                      bordered
                      style={{ padding: "0px 20px", overflowX: "auto" }}
                      columns={columns}
                      dataSource={filteredData}
                      pagination={{
                        pageSize: pageSize,
                        total: totalEntries,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        current: currentPage,
                        onChange: (page) => setCurrentPage(page),
                      }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components}
                        rowSelection={rowSelection}
                    />
                  </div>
                
                </div>
              </div>
            </div>
            </Spin>
            </div>
            </div>
            </div>
           
  )
}


export default Order